import React from "react";
import { Drawer, Box, IconButton, Typography, useTheme } from "@mui/material";
import { Close } from "@mui/icons-material";

interface FormDrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  width?: number | string;
}

export const FormDrawer: React.FC<FormDrawerProps> = ({
  open,
  onClose,
  title,
  children,
  actions,
  width = 500,
}) => {
  const theme = useTheme();
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            width: width,
            maxWidth: "100%",
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 2,
            borderBottom: 1,
            borderColor: "divider",
            bgcolor: theme.palette.action.hover,
          }}
        >
          <Typography variant="subtitle1" fontWeight={600}>
            {title}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Box>
        <Box sx={{ flex: 1, overflowY: "auto" }}>{children}</Box>
        {actions && (
          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: "flex-end",
              p: 2,
              borderTop: 1,
              borderColor: "divider",
              bgcolor: theme.palette.action.hover,
            }}
          >
            {actions}
          </Box>
        )}
      </Box>
    </Drawer>
  );
};
